<p-card styleClass="very-compact-card p-3">
  <div class="flex align-items-center gap-2">
    <h3 class="m-0">История</h3>
    <crm-button-show-and-hide
      [isShow]="historyInfo.showHistory"
      (isShowChange)="isShowChange($event)"></crm-button-show-and-hide>
  </div>

  <div
    *ngIf="historyInfo.showHistory"
    class="mt-3">
    <ng-container *ngIf="!historyInfo.loading">
      <ng-container *ngIf="historyInfo.items as historyItems">
        <div
          *ngIf="historyItems?.length; else notHistory"
          class="mt-2 max-h-29rem overflow-y-auto overflow-x-hidden"
          (scroll)="onScrollEndHistory($any($event.target))">
          <p-timeline
            [value]="historyItems | orderBy: '-date:date'"
            styleClass="history-timeline mt-3">
            <ng-template
              pTemplate="content"
              let-event>
              <ng-container *ngIf="toHistory(event) as event">
                <div class="flex -mt-2 mb-4">
                  <crm-user-avatar [user]="event.user"></crm-user-avatar>
                  <div class="w-full ml-3">
                    <div class="font-medium">{{ event.user?.profile?.name || 'ФРМ' }}</div>
                    <div class="text-400 text-sm">{{ event.date | date: 'dd.MM.yyyy HH:mm' }}</div>
                    <div class="mt-2">
                      <span [innerHTML]="event.field"></span>
                      <ng-container *ngIf="event.oldValue"> c "{{ event.oldValue }}"</ng-container>
                      <ng-container *ngIf="event.newValue"> на "{{ event.newValue }}"</ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-template>
          </p-timeline>

          <div
            *ngIf="historyInfo.paginationLoading"
            class="text-center">
            <p-progressSpinner
              [style]="{
                width: '50px',
                height: '50px'
              }"></p-progressSpinner>
          </div>
        </div>
      </ng-container>

      <ng-template #notHistory>
        <p class="text-xl font-medium mt-2">Нет данных</p>
      </ng-template>
    </ng-container>

    <crm-spinner
      *ngIf="historyInfo.loading"
      top="mt-4 pb-0 mb-4 pb-4"></crm-spinner>
  </div>
</p-card>
